/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Colleague_Filter_DateInputs */

const en_colleague_filter_date = /** @type {(inputs: Colleague_Filter_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Date`)
};

const ja_colleague_filter_date = /** @type {(inputs: Colleague_Filter_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`日付`)
};

const fr_colleague_filter_date = /** @type {(inputs: Colleague_Filter_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Date`)
};

const de_colleague_filter_date = /** @type {(inputs: Colleague_Filter_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Datum`)
};

/**
* | output |
* | --- |
* | "Date" |
*
* @param {Colleague_Filter_DateInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const colleague_filter_date = /** @type {((inputs?: Colleague_Filter_DateInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Colleague_Filter_DateInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_colleague_filter_date(inputs)
	if (locale === "ja") return ja_colleague_filter_date(inputs)
	if (locale === "fr") return fr_colleague_filter_date(inputs)
	return de_colleague_filter_date(inputs)
});